(() => {
  const header = document.querySelector('.avgar-header');
  if (!header || header.dataset.navigationReady) return;
  header.dataset.navigationReady = 'true';
  header.addEventListener('toggle', event => {
    const current = event.target;
    if (!current.matches('.avgar-range-menu[open]')) return;
    current.parentElement.querySelectorAll(':scope > .avgar-range-menu[open]').forEach(menu => {
      if (menu !== current) menu.open = false;
    });
  }, true);
  header.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('details[open]');
    if (!menu) return;
    menu.open = false;
    menu.querySelector('summary').focus();
    event.preventDefault();
  });
  document.addEventListener('click', event => {
    if (header.contains(event.target)) return;
    header.querySelectorAll('details[open]').forEach(menu => { menu.open = false; });
  });
})();
